module.exports = __webpack_public_path__ + "img/universidad-alfonso-ibanez.328e0417.png";